import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import LunchSpecial from './lunchspecial';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };

    const Item = ({ item }) => {
        const [image, setImage] = useState(false);

        useEffect(() => {
            fetchImage(`menu-cat-${item.id}`).then((url) => {
                if (url) {
                    setImage(url);
                }
            });
        }, []);


        const imageCat =
            item.id === 718 ?
            require('./btn-cat/APPETIZERS.png') :
            item.id === 719 ? require('./btn-cat/SOUPS.png')
            : item.id === 720 ? require('./btn-cat/SALADS.png')
            : item.id === 721 ? require('./btn-cat/LA-COMELONA.png')
            : item.id === 722 ? require('./btn-cat/LOS-PECADOS-DE-MARGARITA.png')
            : item.id === 723 ? require('./btn-cat/TACOMANIA.png')
            : item.id === 724 ? require('./btn-cat/SIDES.png')
            : item.id === 725 ? require('./btn-cat/DESSERTS.png')
            : item.id === 726 ? require('./btn-cat/hot-drinks.png')
            : item.id === 727 ? require('./btn-cat/kids-menu.png')
            : item.id === 768 ? require('./btn-cat/COCTAILS.png')
            : item.id === 767 ? require('./btn-cat/drinks.png')
            
            : false;
        

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '48%',
                    height:60,
                    position: 'relative',
                    cursor: 'pointer',
                  
                    borderRadius: 14,
                   
                }}
                onClick={() => {
                    if (item.id === 767) {
                        setShowDrinks(true);
                    } else {
                        setShowListProduct(true);
                        setdishs(item);
                    }
                }}
            >

                {imageCat ? 
                 <img src={imageCat}
                    style={{
                        width: '100%', height: '100%',
                        objectFit: 'cover', borderRadius: 14
                    }} />
                    :   
                     <p
                        style={{
                            position: 'absolute',
                            color: '#fc3fa6',
                            fontWeight: '900',
                            fontSize: 18,
                            textAlign: 'center',
                            paddingInline: 1,
                            fontFamily: 'Abril',
                            textTransform: 'uppercase',
                        }}
                    >
                        {item.name}
                    </p>
            }

                
               
                
            </div>
        );
    };


         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 725) {
                setdesserts(item);
            }
        });
    }, [menus]);


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={false} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 390,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 1,
                                marginBottom: 10,
                            marginLeft: 20,
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        <div
                            onClick={() => {
                              setShowLunchSpecial(true);
                            }}
                            style={{
                             
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                           
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'absolute',
                            right: -20,
                                top: 40,
                            zIndex: 2222

                            
                        }}>
                            <img
                            
                        style={{
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            
                        }}
                        src={require('./assets/boton-lunch-special.png')}
                        />
                        </div>
                        
                       
                    </div>
                    
                    <div style={{paddingInline:50, boxSizing: 'border-box', marginBottom: 20}}>
                        <p style={{color: '#000', fontSize: 14, textAlign: 'center', color: '#fff', fontStyle: 'italic'}}>
                            * Please inform the waiter if you have any type of allergic condition. Parties of 5+ are subject to an automatic 20% gratuity. A 3% surcharge will be added to all credit card transactions.
                        </p>
                    </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box', gap: 10 }}>
                       
                   
                    <div style={{ width: '35%'}}>
                            <video
                             
                            src={require('./assets/bannerhome.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                                width: '100%',
                                height: 438,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                               
                            }}
                        />

                    </div>

                    <div style={{ width: '65%', paddingLeft: 40 }} >
                            
                            
                           <div>
                                <p style={
                                    {
                                        color: '#fff',
                                        fontSize: 30,
                                        fontFamily: "Abril",
                                        textAlign: 'center',
                                        marginTop: 10,
                                     marginBottom: 10
                                    }}>
                                    Choose your favorite category
                                </p>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                gap: 10,
                                height: 360,
                                overflowY: 'auto',
                                paddingRight: 0,
                                    boxSizing: 'border-box',
                                marginTop: 5
                            }}
                        >
                            {menus.map((item, key) => {
                               if (![768, 726, 769, 770].includes(item.id)) {
                                    return <Item item={item} key={key} />;
                                }
                            })}
                        </div>
                    </div>

                    
                </div>
               
            </div>

            <div
                    onClick={() => {
                        setShowListProduct(true)
                        setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <video
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/dessertbanner.mp4')}
                    style={{
                        width: '95%',
                        height: 258,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -30,
                         pointerEvents: 'none',
                       
                        
                        
                    }}
                    />
                {/* <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        marginLeft: 5
                        
                    }}
                    /> */}
                  
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;